import{g as e}from"./generateUtilityClasses-4169ea48.js";import{g as t}from"./createTheme-c3f66f95.js";function r(e){return t("MuiStepIcon",e)}var o=e("MuiStepIcon",["root","active","completed","error","text"]);export{r as g,o as s};
